import { useFormikContext } from 'formik';
import { Label } from '@antimatterhq/ui/components/label';
import { type DataSourceFieldSchemaValues } from '@/zod/schemas/dataSource/DataSourceField';
import { FormDropdown, FormError } from '@/components/form/form';

interface AliasTabProps {
  currentTableFields: string[];
  currentTable: string;
}

export default function AliasTab({ currentTableFields }: AliasTabProps) {
  const formik = useFormikContext<DataSourceFieldSchemaValues>();

  return (
    <div className="mt-4">
      <div>
        <Label htmlFor="selectedField" id="selectedField-label" required>
          Select a field to duplicate with a new alias
        </Label>
        <FormDropdown
          name="alias"
          options={currentTableFields}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.alias}
          aria-labelledby="alias-label"
          placeholder="Select a column to alias"
        />
        <FormError name="alias" />
      </div>
    </div>
  );
}
